import { BookmarksContext } from "@/providers/bookmarks.provider";
import { useContext } from "react";

export function useBookmarks(componentName: string) {
  const context = useContext(BookmarksContext);

  if (!context) {
    throw new Error(
      `useBookmarks must be used within a BookmarksProvider. Component: ${componentName}`,
    );
  }

  return context;
}
